import * as React from 'react'
import ReactPlayer from 'react-player/file'

const ReactVideo = ({video, poster, className, innerclass, ...props}) => {
  return (
    <div className={`react-player-wrapper ${className}`}>
      <ReactPlayer {...props}
        className={`${innerclass}`}
        config={ { file: { attributes: { poster: poster } } } }
        url={video}
        controls={props.controls || true}
        loop={props.loop || false}
        muted={props.muted || false}
      />
    </div>)
}
export default ReactVideo
